import {FormDialogComponent} from "../shared/dialog/form-dialog/form-dialog.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Component, Inject} from "@angular/core";
import {DialogComponentData} from "../shared/dialog/interfaces";
import {DialogService} from "../shared/dialog/dialog.service";
import {FormGroupManager} from "../shared/cml-forms/form-factory.service";
import {DialogComunicationService} from "../shared/dialog/dialog-comunication.service";
import {ValidationService} from "../shared/cml-forms/validation.service";

@Component({
    selector: 'ucetni-jednotka-form-dialog-component',
    templateUrl: '../shared/dialog/form-dialog/form-dialog.component.html',
    styleUrls: ['../shared/dialog/form-dialog/form-dialog.component.scss'],
    standalone: false
})
export class UcetniJednotkaFormDialogComponent extends FormDialogComponent
{
  constructor(dialogService: DialogService,
              dialogRef: MatDialogRef<UcetniJednotkaFormDialogComponent>,
              formManager: FormGroupManager,
              dialogComunicationService: DialogComunicationService,
              validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public override data: DialogComponentData)
  {
    super(dialogRef,data , dialogService, formManager, dialogComunicationService, validationService);
  }

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.form.controls["upload"].valueChanges.subscribe(() => {
      this.loadProvidedFile()
    });

    this.form.controls["kod"].valueChanges.subscribe( () => {
      this.checkExistence("kod","existenceOfKodUj")
    })

    this.form.controls["ico"].valueChanges.subscribe( () => {
      this.checkExistence("ico","existenceOfIco")
    })

    this.form.controls["dic"].valueChanges.subscribe( () => {
      this.checkExistence("dic", "existenceOfDic")
    })
  }
  private checkExistence(controlKey: 'dic' | 'ico' | 'kod', errorKey: 'existenceOfKodUj' | 'existenceOfIco' | 'existenceOfDic'){
    const inputControl = this.form.controls[controlKey]
    const res = this.data.component.checkExistence(controlKey,inputControl.value)
    let errors = inputControl.errors || {};
    res ? errors[errorKey] = true : delete errors[errorKey];
    inputControl.setErrors(Object.keys(errors).length ? errors : null);
  }

  private async loadProvidedFile(){
    const inputControl = this.form.controls["upload"]
    if(!inputControl){
      throw new Error("Form control UPLOAD doesn't exist")
    }
    if(!inputControl.value){
      this.data.component.importedJson = undefined
      return
    }
    let file = new FileReader()
    file.onload = () => {
      this.data.component.importedJson = file.result
      this.data.component.readProvidedJson()
      this.fillFormControls()
      this.form.markAllAsTouched()
    }
    file.readAsText(inputControl.value)

  }

  private fillFormControls(){
    if(this.data.component.parsedJson){
      this.data.component.importFields.forEach( (x: { name: string | number; }) => {
        if(x.name != "upload") //nechceme setovat uploadnuty file odnekud, kde neni
          this.form.controls[x.name].setValue(this.data.component.parsedJson.ucetniJednotka[x.name])
      })
    }
  }
}
